import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabservicenavimumbai() {



    const cardData = {

keyword: "Outstation Cab Service Navi Mumbai",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Outstation Cab Service Navi Mumbai for long-distance travel, family vacations, business trips, pilgrimage tours, weekend getaways, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and safe highway driving, we ensure a smooth, comfortable, and hassle-free outstation travel experience across Maharashtra and India.",

topPlaces: [
    {
        title: "Shirdi",
        description:
            "Shirdi is one of the most popular outstation destinations from Navi Mumbai, attracting millions of Sai Baba devotees throughout the year."
    },
    {
        title: "Nashik & Trimbakeshwar",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, religious sites, and scenic landscapes, making it a preferred travel destination."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station offering strawberry farms, lakes, viewpoints, waterfalls, and a refreshing climate."
    },
    {
        title: "Lonavala & Khandala",
        description:
            "Lonavala and Khandala are scenic hill stations known for caves, valleys, monsoon beauty, and short leisure trips from Navi Mumbai."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is renowned for Mahalaxmi Temple, historical attractions, cultural heritage, and traditional Maharashtrian cuisine."
    },
    {
        title: "Ratnagiri & Ganpatipule",
        description:
            "Ratnagiri and Ganpatipule are famous Konkan destinations offering beautiful beaches, temples, sea forts, and coastal tourism."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad attracts visitors with Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, and significant historical monuments."
    },
    {
        title: "Goa",
        description:
            "Goa is one of India's top holiday destinations known for beaches, nightlife, churches, water sports, and coastal experiences."
    },
    {
        title: "Pandharpur",
        description:
            "Pandharpur is a sacred pilgrimage destination dedicated to Lord Vitthal and attracts devotees from across Maharashtra."
    },
    {
        title: "Saputara",
        description:
            "Saputara is a beautiful hill station near the Maharashtra-Gujarat border known for lakes, viewpoints, ropeway rides, and pleasant weather."
    }
],



services: [
{
name: "Cab Hire in Navi Mumbai",
description: "Cab Hire in Navi Mumbai service by 1Touch Cabs offers reliable transportation solutions for local travel, airport transfers, business trips, family outings, sightseeing tours, and long-distance journeys. We provide Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles with professional chauffeurs. Our service focuses on passenger comfort, safety, punctuality, and affordable pricing. Whether you need a cab for a few hours, a full day, or multiple days, we ensure clean vehicles, experienced drivers, and convenient booking options with 24x7 customer support."
},
{
name: "Outstation Cab Service Navi Mumbai",
description: "Outstation Cab Service Navi Mumbai provides comfortable and dependable transportation for travelers visiting destinations across Maharashtra, Gujarat, Goa, Karnataka, and other states. 1Touch Cabs offers well-maintained vehicles, experienced drivers, flexible travel plans, and transparent pricing. We ensure safe highway travel, timely pickups, and a pleasant journey for families, tourists, corporate travelers, and groups."
},
{
name: "Navi Mumbai Outstation Taxi",
description: "Navi Mumbai Outstation Taxi service offers convenient travel for business trips, vacations, pilgrimages, and weekend getaways. 1Touch Cabs provides clean air-conditioned vehicles, professional chauffeurs, and reliable transportation solutions. Our service ensures passenger comfort, safe travel, and efficient route planning for every journey."
},
{
name: "Outstation Taxi Service from Navi Mumbai",
description: "Outstation Taxi Service from Navi Mumbai delivers reliable transportation to cities, tourist destinations, hill stations, temples, and business centers. 1Touch Cabs offers flexible travel schedules, comfortable vehicles, and experienced drivers. We ensure smooth road journeys and excellent customer service throughout your trip."
},
{
name: "Book Outstation Cab Navi Mumbai",
description: "Book Outstation Cab Navi Mumbai service allows passengers to reserve long-distance transportation quickly and easily. 1Touch Cabs offers instant booking assistance, multiple vehicle options, transparent fares, and dependable chauffeur support. We make travel planning simple and stress-free for every customer."
},
{
name: "Best Outstation Cab Service Navi Mumbai",
description: "Best Outstation Cab Service Navi Mumbai offers premium travel experiences with comfortable vehicles, professional drivers, and reliable customer support. 1Touch Cabs focuses on safety, punctuality, and passenger satisfaction. Our service is ideal for family vacations, business tours, pilgrimages, and intercity travel."
},
{
name: "AC Outstation Cab Navi Mumbai",
description: "AC Outstation Cab Navi Mumbai service provides fully air-conditioned vehicles for comfortable long-distance journeys. 1Touch Cabs offers clean interiors, spacious seating, experienced chauffeurs, and reliable transportation. We ensure a pleasant travel experience regardless of weather conditions or travel distance."
},
{
name: "Private Outstation Taxi Navi Mumbai",
description: "Private Outstation Taxi Navi Mumbai offers exclusive transportation for individuals, families, and corporate travelers. 1Touch Cabs provides dedicated vehicles, customized itineraries, professional chauffeurs, and flexible travel schedules. Our service ensures privacy, convenience, and personalized travel experiences."
},
{
name: "Affordable Outstation Cab Navi Mumbai",
description: "Affordable Outstation Cab Navi Mumbai service provides budget-friendly travel solutions without compromising comfort or safety. 1Touch Cabs offers economical pricing, reliable vehicles, and experienced drivers. We help travelers enjoy convenient long-distance transportation at competitive rates."
},
{
name: "Reliable Outstation Taxi from Navi Mumbai",
description: "Reliable Outstation Taxi from Navi Mumbai ensures dependable transportation for local residents, tourists, and business travelers. 1Touch Cabs offers punctual service, comfortable vehicles, and experienced chauffeurs. We focus on passenger safety, travel convenience, and customer satisfaction throughout every trip."
},
{
name: "24x7 Outstation Cab Service Navi Mumbai",
description: "24x7 Outstation Cab Service Navi Mumbai provides round-the-clock transportation for urgent travel, airport transfers, business trips, and vacations. 1Touch Cabs offers reliable vehicles, professional drivers, and instant booking support. Our service remains available day and night for maximum convenience."
},
{
name: "Outstation Cab Navi Mumbai Fare",
description: "Outstation Cab Navi Mumbai Fare service offers transparent pricing for intercity and long-distance travel. 1Touch Cabs provides affordable fare options for Sedan, SUV, Innova, Innova Crysta, Ertiga, and Tempo Traveller vehicles. We ensure fair pricing with no hidden charges."
},
{
name: "Navi Mumbai Outstation Taxi Charges",
description: "Navi Mumbai Outstation Taxi Charges service provides clear and competitive pricing for outstation transportation requirements. 1Touch Cabs offers flexible fare plans, multiple vehicle choices, and dependable service. We ensure value for money and complete pricing transparency."
},
{
name: "Cheapest Outstation Cab in Navi Mumbai",
description: "Cheapest Outstation Cab in Navi Mumbai service delivers economical travel options for families, individuals, and groups. 1Touch Cabs provides affordable rates, reliable vehicles, and professional chauffeurs. Our service makes long-distance travel accessible without compromising comfort or reliability."
},
{
name: "Outstation Cab Booking Navi Mumbai",
description: "Outstation Cab Booking Navi Mumbai service enables quick and convenient reservations for long-distance journeys. 1Touch Cabs offers instant confirmation, flexible scheduling, multiple vehicle categories, and dedicated customer support. We simplify the booking process for every traveler."
},
{
name: "Navi Mumbai Outstation Cab Price",
description: "Navi Mumbai Outstation Cab Price service offers affordable transportation packages suitable for various travel budgets and requirements. 1Touch Cabs provides transparent pricing, comfortable vehicles, and dependable service. We help customers find the ideal travel option at the right cost."
},
{
name: "Innova Crysta Outstation Cab Navi Mumbai",
description: "Innova Crysta Outstation Cab Navi Mumbai offers premium long-distance transportation with spacious seating and luxury comfort. 1Touch Cabs provides professional chauffeurs, clean vehicles, and smooth highway travel. This service is ideal for families, corporate travelers, and group tours."
},
{
name: "Ertiga Outstation Cab Navi Mumbai",
description: "Ertiga Outstation Cab Navi Mumbai provides comfortable and economical travel for small families and groups. 1Touch Cabs offers air-conditioned vehicles, experienced drivers, and flexible travel options. We ensure safe and enjoyable outstation journeys for every passenger."
},
{
name: "Swift Dzire Outstation Taxi Navi Mumbai",
description: "Swift Dzire Outstation Taxi Navi Mumbai service is perfect for affordable intercity travel and business trips. 1Touch Cabs offers clean vehicles, courteous chauffeurs, and reliable transportation support. We ensure comfortable travel with excellent fuel efficiency and economical fares."
},
{
name: "Sedan Outstation Cab Navi Mumbai",
description: "Sedan Outstation Cab Navi Mumbai provides comfortable transportation for individuals, couples, and small families. 1Touch Cabs offers well-maintained sedans, experienced drivers, and affordable pricing. Our service ensures smooth travel for long-distance and intercity journeys."
},
{
name: "SUV Outstation Taxi Navi Mumbai",
description: "SUV Outstation Taxi Navi Mumbai offers spacious and powerful vehicles suitable for family vacations, group travel, and long-distance road trips. 1Touch Cabs provides comfortable seating, ample luggage space, and professional chauffeur services for a superior travel experience."
},
{
name: "Navi Mumbai to Pune Outstation Cab",
description: "Navi Mumbai to Pune Outstation Cab service provides convenient transportation through the Mumbai-Pune Expressway. 1Touch Cabs offers reliable vehicles, experienced drivers, and comfortable travel arrangements. We ensure safe, punctual, and hassle-free travel between Navi Mumbai and Pune."
},
{
name: "Navi Mumbai to Mumbai Outstation Taxi",
description: "Navi Mumbai to Mumbai Outstation Taxi service offers dependable travel solutions for business meetings, airport transfers, events, and personal trips. 1Touch Cabs provides comfortable vehicles, professional chauffeurs, and efficient city-to-city transportation services."
},
{
name: "Navi Mumbai to Shirdi Cab",
description: "Navi Mumbai to Shirdi Cab service provides reliable transportation for Sai Baba devotees, families, and tourists. 1Touch Cabs offers clean vehicles, experienced drivers, and flexible travel schedules. We ensure comfortable highway travel and convenient pilgrimage transportation."
},
{
name: "Navi Mumbai to Nashik Outstation Cab",
description: "Navi Mumbai to Nashik Outstation Cab service offers comfortable travel for business visits, religious tours, vineyard trips, and family vacations. 1Touch Cabs provides dependable vehicles, professional chauffeurs, and safe travel arrangements throughout the journey."
},
{
name: "Navi Mumbai to Lonavala Outstation Taxi",
description: "Navi Mumbai to Lonavala Outstation Taxi service provides convenient transportation to one of Maharashtra’s most popular hill stations. 1Touch Cabs offers comfortable vehicles, experienced drivers, and flexible travel plans. We ensure a relaxing and enjoyable road trip experience."
},
{
name: "One Way Outstation Cab Navi Mumbai",
description: "One Way Outstation Cab Navi Mumbai service offers affordable single-route transportation for travelers who do not require a return journey. 1Touch Cabs provides transparent pricing, professional chauffeurs, and multiple vehicle options. We ensure convenient, economical, and reliable intercity travel."
}
],

tableData: [
["Cab Hire in Navi Mumbai","Outstation Cab Service Navi Mumbai"],
["Navi Mumbai Outstation Taxi","Outstation Taxi Service from Navi Mumbai"],
["Book Outstation Cab Navi Mumbai","Best Outstation Cab Service Navi Mumbai"],
["AC Outstation Cab Navi Mumbai","Private Outstation Taxi Navi Mumbai"],
["Affordable Outstation Cab Navi Mumbai","Reliable Outstation Taxi from Navi Mumbai"],
["24x7 Outstation Cab Service Navi Mumbai","Outstation Cab Navi Mumbai Fare"],
["Navi Mumbai Outstation Taxi Charges","Cheapest Outstation Cab in Navi Mumbai"],
["Outstation Cab Booking Navi Mumbai","Navi Mumbai Outstation Cab Price"],
["Innova Crysta Outstation Cab Navi Mumbai","Ertiga Outstation Cab Navi Mumbai"],
["Swift Dzire Outstation Taxi Navi Mumbai","Sedan Outstation Cab Navi Mumbai"],
["SUV Outstation Taxi Navi Mumbai","Navi Mumbai to Pune Outstation Cab"],
["Navi Mumbai to Mumbai Outstation Taxi","Navi Mumbai to Shirdi Cab"],
["Navi Mumbai to Nashik Outstation Cab","Navi Mumbai to Lonavala Outstation Taxi"],
["One Way Outstation Cab Navi Mumbai","Cab Hire in Navi Mumbai"]
],















whychoose: [
    {
        WhyChooseheading: "Reliable Outstation Cab Service in Navi Mumbai",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Outstation Cab Services in Navi Mumbai for business trips, family vacations, pilgrimage tours, weekend getaways, and long-distance travel."
    },
    {
        WhyChooseheading: "Comfortable Travel to Popular Destinations",
        WhyChoosedescription: "Travel conveniently from Navi Mumbai to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, Ahmedabad, Ujjain, Hyderabad, and many other destinations."
    },
    {
        WhyChooseheading: "Perfect for Family and Business Travel",
        WhyChoosedescription: "Whether you are planning a holiday, corporate meeting, wedding function, educational tour, or religious journey, our outstation cab services offer a comfortable travel experience."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "We offer flexible travel solutions including one-way cabs, round trips, multi-city tours, same-day return trips, and customized travel packages."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
        WhyChoosedescription: "Pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, Sanpada, CBD Belapur, and all nearby areas."
    },
    {
        WhyChooseheading: "Professional Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our experienced chauffeurs are familiar with interstate and outstation routes, ensuring safe, comfortable, and hassle-free transportation."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Corporate Clients",
        WhyChoosedescription: "From solo travelers and families to corporate teams and large groups, we provide suitable outstation transportation solutions for every requirement."
    }
]
};

const faqData = [
    {
        question: "What is Outstation Cab Service in Navi Mumbai?",
        answer: "Outstation Cab Service provides transportation from Navi Mumbai to destinations outside the city for business travel, tourism, pilgrimages, family visits, and vacations."
    },
    {
        question: "Which destinations are covered under outstation cab services?",
        answer: "Popular destinations include Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, Ahmedabad, Surat, Ujjain, Hyderabad, and many more."
    },
    {
        question: "Can I book a one-way outstation cab?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicles are available for outstation travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Can I customize my outstation travel itinerary?",
        answer: "Yes, customers can add sightseeing locations, multiple destinations, hotel stays, temple visits, and personal stops."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, wedding travel, and pilgrimage tours."
    },
    {
        question: "Can I get pickup from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Do you provide airport to outstation cab services?",
        answer: "Yes, customers can directly travel from Mumbai Airport or Navi Mumbai Airport to outstation destinations."
    },
    {
        question: "Is advance booking recommended for outstation travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and ensure smooth travel planning."
    },
    {
        question: "How can I book an Outstation Cab Service in Navi Mumbai?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rajesh Pawar",
        feedback:
            "We booked an outstation cab from Navi Mumbai to Goa and had a fantastic experience. The vehicle was comfortable, the driver was experienced, and the journey was completely hassle-free.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Patil",
        feedback:
            "Our family trip to Mahabaleshwar was perfectly managed by Mumbai Airport Cabs. The cab was clean, spacious, and the driver was extremely professional throughout the journey.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Service Navi Mumbai",
  "image": "https://www.mumbaiairportcabs.com/assets/images/outstation-cab-service-navi-mumbai.jpg",
  "description": "Book Outstation Cab Service in Navi Mumbai for safe, comfortable, and affordable long-distance travel. Mumbai Airport Cabs offers reliable AC taxis with professional drivers, 24x7 service, and flexible outstation travel packages.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6420"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/outstation-cab-service-navi-mumbai"
  }
};





    return (
        <div>

<Helmet>
  <title>Outstation Cab Service Navi Mumbai | Reliable Long Distance Taxi | +91 9545731161</title>

  <meta
    name="description"
    content="Book Outstation Cab Service in Navi Mumbai for safe and affordable long-distance travel. AC taxi with professional drivers and 24x7 availability."
  />

  <meta
    name="keywords"
    content="cab hire in navi mumbai, Outstation Cab Service Navi Mumbai, Navi Mumbai Outstation Taxi, Outstation Taxi Service from Navi Mumbai, Book Outstation Cab Navi Mumbai, Best Outstation Cab Service Navi Mumbai, AC Outstation Cab Navi Mumbai, Private Outstation Taxi Navi Mumbai, Affordable Outstation Cab Navi Mumbai, Reliable Outstation Taxi from Navi Mumbai, 24x7 Outstation Cab Service Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/121.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationcabservicenavimumbai;